import { render, staticRenderFns } from "./OkzDialog.vue?vue&type=template&id=6e8e1d02&"
import script from "./OkzDialog.vue?vue&type=script&lang=js&"
export * from "./OkzDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports